import { Trans } from "@lingui/macro";
import { currency, percent } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";

export interface TooltipContentExpenseProps {
  showCommission?: boolean;
  showFinalCommission?: boolean;
  plannedExpenses?: number;
  plannedCommission?: number;
  plannedCommissionRelative?: number;
  realExpenses?: number;
  realCommission?: number;
  realCommissionRelative?: number;
}

const TooltipContentExpense = (props: TooltipContentExpenseProps) => {
  if (
    props.plannedExpenses == null ||
    props.plannedCommission == null ||
    props.realExpenses == null ||
    props.realCommission == null
  )
    return null;

  return (
    <div className="flex p-4 pb-5 text-lg" style={{ minWidth: 420 }}>
      <div className="w-1/2 pr-2">
        <div className="font-semibold mb-2">
          <Trans>Planned</Trans>:
        </div>

        <div className="flex mb-1">
          <Trans>Expenses</Trans>:{" "}
          <div className="ml-2">
            {currency.formatByWorkspace(props.plannedExpenses)}
          </div>
        </div>

        {props.showCommission && (
          <div className="flex mb-1">
            <Trans>Commission</Trans>:{" "}
            <div className="ml-2">
              {currency.formatByWorkspace(props.plannedCommission)}
              {props.plannedCommissionRelative != null && (
                <span style={{ marginLeft: 5 }}>
                  ({percent.format(props.plannedCommissionRelative)})
                </span>
              )}
            </div>
          </div>
        )}
      </div>

      <div className="w-1/2 pl-2">
        <div className="font-semibold mb-2">
          <Trans>Spent</Trans>:
        </div>

        <div className="flex mb-1">
          <Trans>Expenses</Trans>:{" "}
          <div className="ml-2">
            {currency.formatByWorkspace(props.realExpenses)}
          </div>
        </div>

        {props.showFinalCommission && (
          <div className="flex mb-1" style={{ whiteSpace: "nowrap" }}>
            <Trans>Final commission</Trans>:{" "}
            <div className="ml-2">
              {currency.formatByWorkspace(props.realCommission)}
              {props.realCommissionRelative != null && (
                <span style={{ marginLeft: 5 }}>
                  ({percent.format(props.realCommissionRelative)})
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(TooltipContentExpense);
